import { Button } from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";

export const SelectTargetButton = ({ record, orderId, isSelectingTarget, selectTargetPallet }) => {
	const translate = useTranslate();
	const isPalletReservedForCurrentOrder = record.reserved_order_id === orderId;

	if (!isSelectingTarget || !isPalletReservedForCurrentOrder || !record.is_target) {
		return null;
	}

	return (
		<Button
			variant="contained"
			color="secondary"
			size="small"
			onClick={() => selectTargetPallet(record)}
		>
			{translate("tab.picking_list.box_movement.buttons.select_as_target")}
		</Button>
	);
};
